const firebaseConfig = {
    apiKey: "AIzaSyCzYjjNHsHHBhRKcKZlqyLbF1_6o7JndZM",
    authDomain: "picsmania-0.firebaseapp.com",
    projectId: "picsmania-0",
    storageBucket: "picsmania-0.appspot.com",
    messagingSenderId: "1027098447705",
    appId: "1:1027098447705:web:2f5c17c724ad04b4438648"
  };
  export default firebaseConfig;